import assert from 'http-assert-plus';
import axios from 'axios';
import ms from 'ms';
import Vue from 'vue';
import * as Sentry from '@sentry/browser';

const sessionStorage = 'sessionStorage' in global && global.sessionStorage ? global.sessionStorage : null;
let statuses = [];

export async function fetchLatestStatus({ force = false } = {}) {
  try {
    const ifNoneMatch = sessionStorage && !force && sessionStorage.getItem('status:latest');
    const { status, headers, data } = await axios.get('/api/status.json', {
      headers: { 'If-None-Match': ifNoneMatch },
      timeout: ms('10s'),
      validateStatus: s => s <= 500,
    });

    if (status === 200) {
      const { etag } = headers;
      sessionStorage && sessionStorage.setItem('status:latest', etag);
      statuses = (data && Array.isArray(data.statuses) ? data.statuses : [])
        .filter(status => status && (typeof status.path === 'string' || (Array.isArray(status.path) && status.path.length)));
    } else if (status !== 304) {
      const { errorMessage, extensions } = data && data.error ? data.error : {};
      assert.fail(status, errorMessage || 'An error occurred fetching the status route', { ...extensions });
    }
  } catch (err) {
    Vue.$log.error(err);
    Sentry.captureException(err);
  }
}

let statusInterval = null;
export function startFetchingLatestStatus() {
  // Start fetching the status
  fetchLatestStatus({ force: true });
  // Setup an interval to continuously fetch the status
  statusInterval = setInterval(() => fetchLatestStatus(), ms('15s'));
}
export function stopFetchingLatestStatus() {
  statusInterval && clearInterval(statusInterval);
}

export function getStatusesForRoute(route) {
  const paths = [
    route.path,
    ...(Array.isArray(route.matched) ? route.matched.map(m => m.path) : []),
    '*',
  ];

  return statuses.filter(status => {
    if (Array.isArray(status.path)) {
      return status.path.find(p => paths.includes(p));
    } else {
      return paths.includes(status.path);
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/status.js